import { ChangeEvent, FocusEvent, useState } from 'react';
import { CellProps } from 'react-table';
import TextField from '../../../../component/TextField';
import EditableCell from './EditableCell';

const NoteCell = ({ row, tableOptions }: CellProps<any>) => {
	const { updateRowData } = tableOptions;
	const rowData = row.original;

	const [inputValue, setInputValue] = useState(rowData?.notes);

	return (
		<EditableCell
			className="min-w-150px"
			textValue={rowData?.notes}
			editComponent={({ setEnableEditing }: any) => {
				return (
					<TextField
						className="w-100"
						inputClassName="w-100"
						name="notes"
						value={inputValue}
						onChange={(e: ChangeEvent<HTMLInputElement>) => {
							setInputValue(e.target.value);
						}}
						onBlur={(e: FocusEvent<HTMLInputElement>) => {
							updateRowData(row.index, () => ({
								notes: inputValue,
							}));
							setEnableEditing(false);
						}}
						autoFocus={true}
					/>
				);
			}}
		/>
	);
};

export default NoteCell;
